import { Component, inject, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { filter } from 'rxjs';

@Component({
  selector: 'qaroni-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent extends QarepaBaseSubsDirective implements OnInit {
  title = 'qaroni-qbono-merchant';

  private router = inject(Router);
  private renderer = inject(Renderer2);

  private routesToHideBadge = [
    new RegExp('^/dashboard/tickets/[^/]+/details$'),
    new RegExp('^/supports/tickets/[^/]+/details$'),
  ];

  private routerEvent$ = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd)
  );

  ngOnInit(): void {
    this.subs.add(this.routerEvent$.subscribe(this.getRouterEvent));
  }

  private getRouterEvent = (event): void => {
    const navEndEvent = event as NavigationEnd;
    const currentUrl = navEndEvent.urlAfterRedirects;

    const hidden = this.routesToHideBadge.some(pattern => {
      if (pattern instanceof RegExp) {
        return pattern.test(currentUrl);
      } else {
        return currentUrl.startsWith(pattern);
      }
    });

    if (hidden) {
      this.renderer.addClass(document.body, 'hide-recaptcha-badge');
    } else {
      this.renderer.removeClass(document.body, 'hide-recaptcha-badge');
    }
  };
}
